import { p as D, a as L, c as f, d as x, e as m, f as y, h as T, i as u, j as C, k as F, l as S, m as P, n as B, o as E, q as M, r as b, s as I, u as v, v as W, w as $, x as A, y as w, z as j, A as q, B as z, C as G, D as H, E as J, F as K, G as N, H as O, I as Q, J as R, K as U, L as V, M as X, N as Y, O as a, P as e, Q as r, R as i, S as n, T as l, U as Z, V as _, W as s, X as g, Y as o, Z as p, _ as d, $ as aa, a0 as ta, a1 as ea, a2 as ra, a3 as ia, a4 as na, a5 as la, a6 as sa, a7 as ga, a8 as oa, a9 as pa, aa as da, ab as ka, ac as ca, ad as ha, ae as Da, af as La, ag as fa, ah as xa, ai as ma, aj as ya, ak as Ta, al as ua, am as Ca, an as Fa, ao as Sa, ap as Pa, aq as Ba, ar as Ea, as as Ma, at as ba, au as Ia, av as va, aw as Wa, ax as $a, ay as Aa, az as wa, aA as t, aB as k, aC as ja, aD as c, aE as qa, aF as h, aG as za, aH as Ga, aI as Ha } from "../tokens-D9z8Q6nJ.js";
import { lighten as Ja, darken as Ka } from "@mui/material";
const Qa = {
  light: {
    palette: {
      primary: {
        main: D,
        dark: L,
        light: f,
        contrastText: x,
        faint: m
      },
      secondary: {
        main: y,
        dark: T,
        light: u,
        contrastText: C,
        faint: F
      },
      error: {
        main: S,
        dark: P,
        light: B,
        contrastText: E,
        faint: M
      },
      warning: {
        main: b,
        dark: I,
        light: v,
        contrastText: W,
        faint: $
      },
      info: {
        main: A,
        dark: w,
        light: j,
        contrastText: q,
        faint: z
      },
      success: {
        main: G,
        dark: H,
        light: J,
        contrastText: K,
        faint: N
      },
      text: {
        primary: O,
        secondary: Q,
        disabled: R
      },
      cta: {
        main: U,
        light: V,
        dark: X,
        contrastText: Y
      },
      flagged: {
        main: a,
        light: e,
        dark: r,
        contrastText: i,
        faint: n
      },
      background: {
        default: l,
        paper: l
      },
      action: {
        disabled: "#99a1ad",
        disabledBackground: Z
      },
      divider: _,
      Alert: {
        flaggedColor: r,
        flaggedStandardBg: Ja(e, 0.9),
        flaggedFilledBg: a,
        flaggedFilledColor: i,
        flaggedIconColor: a
      }
    }
  },
  dark: {
    overlays: [
      "",
      `linear-gradient(${s}, ${s})`,
      `linear-gradient(${g}, ${g})`,
      `linear-gradient(${o}, ${o})`,
      `linear-gradient(${p}, ${p})`,
      `linear-gradient(${d}, ${d})`,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ],
    palette: {
      primary: {
        main: aa,
        dark: ta,
        light: ea,
        contrastText: ra,
        faint: ia
      },
      secondary: {
        main: na,
        dark: la,
        light: sa,
        contrastText: ga,
        faint: oa
      },
      error: {
        main: pa,
        dark: da,
        light: ka,
        contrastText: ca,
        faint: ha
      },
      warning: {
        main: Da,
        dark: La,
        light: fa,
        contrastText: xa,
        faint: ma
      },
      info: {
        main: ya,
        dark: Ta,
        light: ua,
        contrastText: Ca,
        faint: Fa
      },
      success: {
        main: Sa,
        dark: Pa,
        light: Ba,
        contrastText: Ea,
        faint: Ma
      },
      text: {
        primary: ba,
        secondary: Ia,
        disabled: va
      },
      cta: {
        main: Wa,
        light: $a,
        dark: Aa,
        contrastText: wa
      },
      flagged: {
        main: t,
        light: k,
        dark: ja,
        contrastText: c,
        faint: qa
      },
      background: {
        default: h,
        paper: h
      },
      action: {
        disabled: za,
        disabledBackground: Ga
      },
      divider: Ha,
      Alert: {
        flaggedColor: n,
        flaggedStandardBg: Ka(k, 0.9),
        flaggedFilledBg: t,
        flaggedFilledColor: c,
        flaggedIconColor: t
      }
    }
  }
};
export {
  Qa as default
};
